import { useTranslation } from 'react-i18next';

import { DocumentUnderstandingAgentPricesStrategy } from 'services/repositories/documentUnderstandingAgent/documentUnderstandingAgent';

import { PRICE_STRATEGY_LABEL_KEYS } from '../../../../helpers';
import { GlobalValue } from '../GlobalValue/GlobalValue';

type PriceStrategyCellProps = {
  strategy: DocumentUnderstandingAgentPricesStrategy | null;
};

export const PriceStrategyCell = ({ strategy }: PriceStrategyCellProps) => {
  const { t } = useTranslation();

  if (!strategy) {
    return <GlobalValue />;
  }

  return <span className="text-gray-700">{t(PRICE_STRATEGY_LABEL_KEYS[strategy])}</span>;
};

/**
 * i18n keys
 * t('settings:documentUnderstandingAgent.global.priceStrategy.strategy.disabled')
 * t('settings:documentUnderstandingAgent.global.priceStrategy.strategy.document')
 * t('settings:documentUnderstandingAgent.global.priceStrategy.strategy.documentAndMasterData')
 * t('settings:documentUnderstandingAgent.global.priceStrategy.strategy.masterData')
 */
